import React from 'react';
import type { ElementRef, Ref } from 'react';

import { styled } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

export interface TagLabelProps {
  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLSpanElement>;

  /**
   * The children elements
   */
  children: string;
}

const TagLabelEl = styled('span', {
  fontSize: '$tsm',
  fontWeight: '$bold',
});

const TagLabel = React.forwardRef<ElementRef<typeof TagLabelEl>, TagLabelProps>(
  (props, ref) => {
    return <TagLabelEl ref={ref} {...props} />;
  }
);

TagLabel.displayName = 'TagLabel';

export default TagLabel;
